import * as S from '~/components/molecules/Mdx/styled'
import { ContentBanner } from '~/components/molecules/ContentBanner'
import React from 'react'
import { PdfViewer } from '~/components/molecules/PdfViewer'

const hr = () => (
  <div className={'hr'}>
    <S.HorizontalBreak />
  </div>
)

export const components = {
  ContentBanner,
  hr,
  PdfViewer,
}
